<div class="detail-page">
  <app-asiakas-otsikko otsikko="Kirjanpidon ulkopuoliset vähennykset" paluuUrl="/asiakkaat" [asiakas]="asiakas()"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div class="mat-elevation-z3" style="padding: 20px; margin: 20px; position: relative">
      <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Ulkopuoliset kulut: <a [href]="ulkopuolisetKulutEncodedUriObservable | async" target="_BLANK">{{ ulkopuolisetKulutUriObservable | async }}</a>
      </div>
    </div>
  }

  <mat-form-field appearance="fill">
    <mat-label>Valitse vuosi</mat-label>
    <mat-select [formField]="vuosi">
      @for (year of yearRange; track year) {
        <mat-option [value]="year">{{ year }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (asiakas()?.avain) {
    <div>
      @if (selectedYear() === 2019) {
        <div app-ajopaivakirja-lemonator [asiakasAvain]="asiakas().avain"></div>
      } @else {
        <div app-ulkopuoliset-kulut [asiakasAvain]="asiakas().avain" [setYear]="selectedYear()"></div>
      }
    </div>
  }
</div>
